import { IBaseQuery } from "../../models/base/base-query";

const hasUsableFilterValue = (value: IBaseQuery["filters"][number]["value"]) => {
  if (value === undefined || value === null || value === "") return false;
  if (Array.isArray(value)) return value.length > 0;
  return true;
};

export const hasRequiredStaticFilters = (
  query: IBaseQuery | undefined,
  requiredFilterNames: string[]
) => {
  const filters = query?.filters ?? [];

  return requiredFilterNames.every((requiredName) =>
    filters.some(
      (filter) =>
        filter.name === requiredName && hasUsableFilterValue(filter.value)
    )
  );
};
